import { render } from "./Store.vue?vue&type=template&id=6606377c&ts=true"
import script from "./Store.vue?vue&type=script&lang=ts"
export * from "./Store.vue?vue&type=script&lang=ts"

import "./Store.vue?vue&type=style&index=0&id=6606377c&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__